import {
  Combobox,
  ComboboxOptions,
  ComboboxButton,
  ComboboxOption,
  Transition,
} from '@headlessui/react';

export function LanguageDropdownButton({ onSelect, items, value, position }) {
  return (
    <div className="relative">
      <Combobox value={value} onChange={onSelect}>
        <ComboboxButton
          aria-label="lang"
          className="btn btn-text btn-icon max-sm:btn-sm"
        >
          <i className="icon-world_2 text-[24px]" />
        </ComboboxButton>
        <Transition
          as="div"
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <ComboboxOptions
            modal={false}
            className={`absolute max-lg:right-0 lg:left-0 z-10 mt-2 flex w-screen max-w-max ${position}`}
          >
            <div className="bg-white p-6 shadow flex flex-col gap-2.5 rounded-20 min-w-[220px]">
              {items.map((item) => (
                <ComboboxOption
                  className={`flex gap-x-3 py-1.5 px-3 rounded-10 items-center hover:bg-slate-100 cursor-pointer ${
                    value === item.value ? 'bg-emerald-50' : ''
                  }`}
                  as="div"
                  key={item.value}
                  value={item}
                >
                  <i
                    className={`text-[24px] leading-6 text-slate-500 ${item.icon}`}
                  />
                  <span className="text-slate-800 text-base font-medium leading-3">
                    {item.text}
                  </span>
                </ComboboxOption>
              ))}
            </div>
          </ComboboxOptions>
        </Transition>
      </Combobox>
    </div>
  );
}
